import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { CartProvider } from "./context/CartContext";
import { Layout } from "./components/Layout";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import CheckoutPage from "./pages/CheckoutPage";
import NeighborhoodPage from "./pages/NeighborhoodPage";
import { AboutPage, ContactPage, DeliveryPage, FaqPage, HowToOrderPage } from "./pages/InfoPages";
import { AgeEligibilityPage, PrivacyPage, TermsPage } from "./pages/LegalPages";
import { SEO } from "./components/SEO";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-28 text-center" data-testid="not-found-page">
      <SEO title="Page Not Found" path="/404" />
      <p className="font-display text-7xl font-black text-brand-gold/40">404</p>
      <h1 className="mt-4 text-3xl font-black text-brand-forest">This page took a walk.</h1>
      <p className="mt-3 text-brand-ink/60">The menu, however, is right where you left it.</p>
      <Link to="/shop" data-testid="notfound-shop-link" className="mt-8 inline-block rounded-full bg-brand-pine px-8 py-4 font-display text-sm font-bold uppercase tracking-[0.15em] text-brand-cream">
        Shop the Menu
      </Link>
    </div>
  );
}

export default function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <CartProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="/shop" element={<ShopPage mode="shop" />} />
            <Route path="/category/:categoryId" element={<ShopPage mode="category" />} />
            <Route path="/search" element={<ShopPage mode="search" />} />
            <Route path="/product/:slug" element={<ProductPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/delivery" element={<DeliveryPage />} />
            <Route path="/how-to-order" element={<HowToOrderPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/areas/:slug" element={<NeighborhoodPage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/age-eligibility" element={<AgeEligibilityPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </CartProvider>
    </BrowserRouter>
  );
}
